// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadTaskDetail-module__consentLink___xGZg0 {
  color: #18181b;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
}

.LeadTaskDetail-module__consentLink___xGZg0:hover {
  color: #3f3f46;
}

.LeadTaskDetail-module__consentActions___bP13V {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/LeadTaskDetail/LeadTaskDetail.module.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,0BAAA;EACA,0BAAA;EACA,qBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AADF","sourcesContent":["// Only the lead-specific bits live here; everything else reuses TaskDetail.module.scss.\n\n.consentLink {\n  color: #18181b;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  word-break: break-all;\n}\n\n.consentLink:hover {\n  color: #3f3f46;\n}\n\n.consentActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"consentLink": `LeadTaskDetail-module__consentLink___xGZg0`,
	"consentActions": `LeadTaskDetail-module__consentActions___bP13V`
};
module.exports = ___CSS_LOADER_EXPORT___;
